// eslint-disable-next-line no-shadow
enum ReduxConstants {
    SET_RENDERER_CURRENT_USER,
    UPDATE_APPLICATION_PRELOADED_SPLASH_SCREENS,
    SET_APPLICATION_IS_APP_NOT_UPDATED,
}

export default ReduxConstants
